import { useEffect } from 'react';

/**
 * Hook para prevenir el shift del contenido cuando se oculta la scrollbar
 * Usar en modales que no usan StandardModal
 */
export const usePreventScrollShift = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      // Calcular el ancho de la scrollbar
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      // Aplicar overflow hidden y compensar con padding
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      // Restaurar valores originales
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    // Cleanup al desmontar
    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [isOpen]);
};

export default usePreventScrollShift;
